__turbopack_context__.v({
  "author": "news-card-skeleton-module__8AjWYq__author",
  "authorInfo": "news-card-skeleton-module__8AjWYq__authorInfo",
  "authorName": "news-card-skeleton-module__8AjWYq__authorName",
  "authorRole": "news-card-skeleton-module__8AjWYq__authorRole",
  "avatar": "news-card-skeleton-module__8AjWYq__avatar",
  "card": "news-card-skeleton-module__8AjWYq__card",
  "content": "news-card-skeleton-module__8AjWYq__content",
  "imageContainer": "news-card-skeleton-module__8AjWYq__imageContainer",
  "meta": "news-card-skeleton-module__8AjWYq__meta",
  "metaRight": "news-card-skeleton-module__8AjWYq__metaRight",
  "readTime": "news-card-skeleton-module__8AjWYq__readTime",
  "shimmer": "news-card-skeleton-module__8AjWYq__shimmer",
  "skeleton": "news-card-skeleton-module__8AjWYq__skeleton",
  "textLine": "news-card-skeleton-module__8AjWYq__textLine",
  "textLineShort": "news-card-skeleton-module__8AjWYq__textLineShort",
  "title": "news-card-skeleton-module__8AjWYq__title",
});
